import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

// `import type` y no un import normal: `form-pay-plan` ya importa de `@common/services`, así que un
// import de valor cerraría un ciclo en runtime. El tipo se borra al compilar.
import type { PayPlanModalMode } from '../containers/form-pay-plan/form-pay-plan.component';

/**
 * Pedido de apertura del modal "Plan y SMS". Sin datos es modo `'pay'` (pagar el plan actual), que
 * es lo que siempre pidió el banner de renovación de pago.
 */
export interface PaymentPlanModalRequest {
    mode?: PayPlanModalMode;
    /**
     * En `'change-plan'`, preselecciona el plan inmediatamente superior al actual. Lo usa el límite
     * semanal de Nina al mandar a actualizar el plan.
     */
    preselectNextPlan?: boolean;
}

@Injectable({
    providedIn: 'root',
})
export class PaymentPlanModalRequestService {
    private readonly openRequestedSubject = new Subject<PaymentPlanModalRequest | undefined>();

    /** Es un `Subject`: no repite eventos pasados. Quien pide abrir tiene que esperar a que `form-pay-plan` esté montado. */
    readonly openRequested$: Observable<PaymentPlanModalRequest | undefined> = this.openRequestedSubject.asObservable();

    requestOpen(request?: PaymentPlanModalRequest): void {
        this.openRequestedSubject.next(request);
    }
}
